export const updateBaseTableReducer = (stateList, data, pagination = {}) => {
  const { total } = pagination;

  return {
    ...stateList,
    isLoading: false,
    data,
    total
  };
};
